import { RotateCw } from 'lucide-react';

import './styles.css';

const DEFAULT_MESSAGE = 'Não foi possível gerar este conceito';

/**
 * Copy própria do front para os motivos que ele conhece. Um motivo desconhecido
 * cai na `message` que o backend enviou, o que permite explicar causas novas
 * sem depender de um deploy do front.
 */
const MESSAGE_BY_REASON = {
    rate_limit: 'Limite de requisições atingido. Tente novamente em instantes.',
};

/**
 * Ocupa a célula de uma ideia cuja geração de conceito falhou, para que o grid
 * não fique com um skeleton preso nem com um buraco silencioso.
 *
 * O botão de recarregar exige `onRetry` e uma falha recuperável: sem callback não
 * há ação possível, e com `retryable: false` uma nova tentativa não resolveria.
 * `retryable` ausente vale como `true` — o fallback pelo endpoint agregado não
 * emite o campo.
 */
export default function ConceptCardFailed({ title, onRetry, reason, message, retryable = true }) {
    const failureText = MESSAGE_BY_REASON[reason] || message || DEFAULT_MESSAGE;

    return (
        <div className="concept-card-failed">
            <p className="concept-card-failed-title">{title}</p>
            <p className="concept-card-failed-message">{failureText}</p>
            {onRetry && retryable && (
                <button
                    type="button"
                    className="concept-card-failed-retry"
                    aria-label="Recarregar conceito"
                    onClick={onRetry}
                >
                    <RotateCw size={16} aria-hidden="true" />
                    Recarregar
                </button>
            )}
        </div>
    );
}
